import React from 'react'
import styles from './PopupCoin.module.css';

function CoinPopup({ amount }: { amount: number }) {
  return (
    <div className={styles.dfx_coinPopupOverlay}>
      <div className={styles.dfx_coinPopupContainer}>
        <div className={styles.dfx_coinPopupIcon}>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img src="./PopupCoinIcon.webp" alt="PopupCoinIcon" />
        </div>
        <div className={styles.dfx_coinPopupBody}>
          <h2 className={styles.dfx_coinPopupContent}>Success</h2>
          <p className={styles.dfx_coinPopupDesc}>+{amount} coins</p>
        </div>
      </div>
    </div>
  )
}

export default CoinPopup